<template>
  <div class="flex bg">
    <template v-if="isCancel">
      <p class="flex1 tac fs12 color_333 pt5 pb5" v-if="isPersonal">{{ consult.consultStatusDescription }}</p>
    </template>
    <template v-if="isNopayCancel">
      <p class="flex1 tac fs12 color_333 pt5 pb5" v-if="isPersonal">{{ consult.consultStatusDescription }}</p>
    </template>
  </div>
</template>

<script>
import {consultMixin} from "@/lib/mixins/consult";

export default {
  name: "sub-bottom",
  mixins: [consultMixin],
  props: ['status', 'message', 'consult', 'server'],

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/consult/sub-bottom.vue